import { Button, Modal, TextInput, Textarea } from 'flowbite-react';
import { useEffect, useState } from 'react';
import { Equipment } from '../../Models/Equipment';
import { RequestQuoteForm } from '../../Models/RequestQuoteForm';
import { toast } from 'react-toastify';
import RequestQuoteApi from '../../Api/RequestQuoteApi';
import Loader from '../Common/Loader';

export default function RequestQuote({
  equipment,
  show,
  setShow,
}: {
  equipment: Equipment | null | undefined;
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [formActive, setFormActive] = useState<boolean>(true);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const [formData, setFormData] = useState<RequestQuoteForm>({
    id: 0,
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    questionsComments: '',
    clientId: null,
    contactId: null,
    equipmentId: equipment?.id ?? null,
    equpiment: equipment ?? null,
  });

  useEffect(() => {
    handleSetInitialValues();
  }, []);

  const handleSetInitialValues = () => {
    const values = formData
      ? {
          ...formData,
        }
      : {
          id: 0,
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          subject: '',
          questionsComments: '',
          clientId: null,
          contactId: null,
          equipmentId:
            equipment === null || equipment === undefined ? null : equipment.id,
          equipment: equipment ?? null,
        };

    setFormActive(true);
    setFormData(values as RequestQuoteForm);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const handleChangeTextArea = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const onSubmit = (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    setButtonDisabled(true);
    if (equipment) formData.equipmentId = equipment?.id;
    try {
      setIsLoading(true);
      return RequestQuoteApi.addRequestQuote(formData)
        .then((res) => {
          toast.success('success');
          setIsLoading(false);
          setFormActive(false);
          setButtonDisabled(false);
        })
        .catch((err) => {
          toast.error('Error: ' + err);
          setIsLoading(false);
          setButtonDisabled(false);
        });
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      setButtonDisabled(false);
    }
  };
  function onCloseModal() {
    setShow(false);
  }
  return (
    <Modal show={show} size='2xl' onClose={onCloseModal} popup>
      <Modal.Header title='Request Quote'>Request Quote</Modal.Header>
      <Modal.Body>
        <div className='w-full mt-2'>
          {isLoading && <Loader />}
          {formActive && (
            <form className='p-0 w-full' onSubmit={onSubmit}>
              <div className='flex gap-2'>
                <div className='content-center'>
                  <span>Hi, my name is </span>
                </div>
                <div>
                  <TextInput
                    id='firstName'
                    name='firstName'
                    type='text'
                    placeholder='First Name'
                    onChange={handleChange}
                    value={formData.firstName ?? ''}
                    //   required
                  />
                </div>
                <div>
                  <TextInput
                    id='lastName'
                    name='lastName'
                    type='text'
                    placeholder='Last Name'
                    onChange={handleChange}
                    value={formData.lastName ?? ''}
                    //   required
                  />
                </div>
              </div>
              <div className='flex gap-2'>
                <div className='content-center'>
                  <span>
                    and I would like to get more information on this{' '}
                    {equipment?.number}
                  </span>
                </div>
              </div>
              <div className='flex gap-2'>
                <div className='content-center'>
                  <span>I can be reached by email at </span>
                </div>
                <div>
                  <TextInput
                    id='email'
                    name='email'
                    type='text'
                    placeholder='Email'
                    onChange={handleChange}
                    value={formData.email ?? ''}
                    //   required
                  />
                </div>
              </div>
              <div className='flex gap-2'>
                <div className='content-center'>
                  <span>or by phone at </span>
                </div>
                <div>
                  <TextInput
                    id='phone'
                    name='phone'
                    type='text'
                    placeholder='Phone'
                    onChange={handleChange}
                    value={formData.phone ?? ''}
                    //   required
                  />
                </div>
              </div>
              <div className='pb-3'>
                <div>
                  <Textarea
                    id='questionsComments'
                    name='questionsComments'
                    placeholder='Questions/Comments'
                    onChange={handleChangeTextArea}
                    //   value={formData.bio ?? ''}
                    //   sizing='md'
                    rows={2}
                  />
                </div>
              </div>
              <Button
                type='submit'
                className='buttonMain w-full md:w-1/2 mx-auto'
                disabled={buttonDisabled}
              >
                Submit
              </Button>
            </form>
          )}
          {!formActive && (
            <div className='p-2 w-full flex text-center'>
              Thank You for your intrest.
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}
